import type { FaucetClaimParams } from "api";
import { api } from "api";
import useAsyncFn from "react-use/lib/useAsyncFn";
import { useAccount } from "wagmi";

import { useUnpausedForkStatus } from "../context";
import { useMyAssets } from "./MyAssetsProvider";

export interface UseFaucetClaimResult {
  loading: boolean;
  error?: Error;
  claim: (params: FaucetClaimParams) => Promise<void>;
}

export default function useFaucetClaim(): UseFaucetClaimResult {
  const { address: account } = useAccount();
  const { executionId } = useUnpausedForkStatus();
  const { tokens, native } = useMyAssets();
  const { retry: refreshMyTokens } = tokens;
  const { refresh: refreshNative } = native;

  const [{ loading, error }, claim] = useAsyncFn(
    async (params: FaucetClaimParams) => {
      if (!account) {
        return;
      }
      await api.claimFromFaucet(executionId, account, params);
      refreshMyTokens();
      refreshNative();
    },
    [account, executionId, refreshMyTokens, refreshNative],
  );

  return {
    loading,
    error,
    claim,
  };
}
